import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Client } from "../../api-client";
import { TABLE_ROWS_COUNT } from "../../../shared/constants";
import {
  API_CREATE_MILESTONE,
  API_DELETE_MILESTONE,
  API_GET_MILESTONES_BY_PROJECT,
  API_GET_MILESTONE,
  API_MILESTONES_LIST,
  API_PATCH_MILESTONE_ORDER,
  API_UPDATE_MILESTONE,
} from "../../../shared/routes/private.routes";

export const getMilestonesByProject: any = createAsyncThunk(
  "milestone/getByProject",
  async (projectId: string) => {
    return Client.get(API_GET_MILESTONES_BY_PROJECT, {
      params: { project_id: projectId },
    });
  }
);

export const getMilestonesList: any = createAsyncThunk(
  "milestone/getList",
  async ({ body, params }: { body?: any; params?: any }) => {
    return Client.post(API_MILESTONES_LIST, body || {}, { params });
  }
);

export const getMilestoneById: any = createAsyncThunk(
  "milestone/getById",
  async (milestoneId: string) => {
    return Client.get(API_GET_MILESTONE + milestoneId);
  }
);

export const createMilestone: any = createAsyncThunk(
  "milestone/create",
  async (body: any) => {
    return Client.post(API_CREATE_MILESTONE, body);
  }
);

export const updateMilestone: any = createAsyncThunk(
  "milestone/update",
  async ({ milestoneId, body }: { milestoneId: string; body: any }) => {
    return Client.put(API_UPDATE_MILESTONE + milestoneId, body);
  }
);

export const patchMilestone: any = createAsyncThunk(
  "milestone/patch",
  async ({ milestoneId, body }: { milestoneId: string; body: any }) => {
    return Client.patch(API_UPDATE_MILESTONE + milestoneId, body);
  }
);

export const patchMilestoneOrder: any = createAsyncThunk(
  "milestone/patchOrder",
  async ({ milestoneId, order }: { milestoneId: string; order: number }) => {
    return Client.patch(API_PATCH_MILESTONE_ORDER + milestoneId + "/order", {
      order,
    });
  }
);

export const deleteMilestone: any = createAsyncThunk(
  "milestone/delete",
  async (milestoneId: string) => {
    return Client.delete(API_DELETE_MILESTONE + milestoneId);
  }
);

const milestoneSlice = createSlice({
  name: "milestone",
  initialState: {
    loadingMilestonesList: false,
    milestonesList: [] as any[],
    pagination: { page: 1, limit: TABLE_ROWS_COUNT, total: 0 },
  },
  reducers: {
    resetMilestonesList: (state) => {
      state.milestonesList = [];
      state.pagination = { page: 1, limit: TABLE_ROWS_COUNT, total: 0 };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMilestonesList.pending, (state) => {
        state.loadingMilestonesList = true;
        state.milestonesList = [];
      })
      .addCase(getMilestonesList.fulfilled, (state, action) => {
        state.loadingMilestonesList = false;
        state.milestonesList = action?.payload?.data?.data ?? [];
        state.pagination = {
          page: action?.payload?.data?.page ?? 1,
          limit: action?.payload?.data?.limit ?? TABLE_ROWS_COUNT,
          total: action?.payload?.data?.total ?? 0,
        };
      })
      .addCase(getMilestonesList.rejected, (state) => {
        state.loadingMilestonesList = false;
        state.milestonesList = [];
      });
  },
});

export const { resetMilestonesList } = milestoneSlice.actions;
export default milestoneSlice.reducer;
